import Dashboards from "./components/Dashboards";
import PageNotFound from "./components/PageNotFound";
import Testpage from '../src/components/testpage'

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import TDCLandingPage from "./components/TDCLandingPage";










const About = () => {
  return <h1>About</h1>
};


function App() {
  return (
    <div>
    
      <Routes>
        <Route path='/' element = {<TDCLandingPage/>}/>
        <Route path='/dashboard' element = {<Dashboards/>}/>
        <Route path='*' element = {<PageNotFound/>}/>
      
      </Routes>
   
    </div>

  );
}

export default App;
